import { v4 as uuid } from "uuid";

import store from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'

import {MODAL_POPUP_TYPES} from "@/actions/globalConst";
import CommunicationCycleAPI from "@/api/CommunicationCycleAPI";

import {Dossier} from "@/models/Dossier";

export const initialState = {
  show: false,
  modal: "",
  key: "",
  options: {}
};

export const nextActionEvent = createAsyncThunk("nextAction", async (data:any = null, event) => {
    let response = null;
    try {
          response = await CommunicationCycleAPI.setnextAction(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


const ModalPopupReducer = createSlice({
  name: 'ModalPopupReducer',
  initialState,
  reducers: {
      showStoreConfirmModal(state, action) {
          state.modal = MODAL_POPUP_TYPES.STORE_CONFIRM;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
      showConfirmModal(state, action) {
          state.modal = MODAL_POPUP_TYPES.REMOVE_CONFIRM;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
      showInvoiceAddRow(state, action) {
          state.modal = MODAL_POPUP_TYPES.ADD_INVOICE_ROW;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
      addDocument(state, action) {
          state.modal = MODAL_POPUP_TYPES.ADD_DOCUMENT;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
      showSettingsStorageBasemapSelect(state, action) {
          state.modal = MODAL_POPUP_TYPES.SETTINGS_SET_STORAGE_BASEMAP;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
      searchWorkprocess(state, action) {
          state.modal = MODAL_POPUP_TYPES.SEARCH_WORKPROCESS;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
      closeTask(state, action) {
          state.modal = MODAL_POPUP_TYPES.CLOSE_TASK;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },          
      addWorklog(state, action) {
          state.modal = MODAL_POPUP_TYPES.ADD_WORKLOG;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
      detailDossier(state, action) {
          state.modal = MODAL_POPUP_TYPES.DETAIL_DOSSIER;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
      addCalenderItem(state, action) {
          state.modal = MODAL_POPUP_TYPES.ADD_CALENDER_ITEM;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          
          if(action.payload?.extraData) {
              if(action.payload?.extraData instanceof Dossier) {
                let dossierKeys = action.payload?.extraData.getDossierKeys();
                
                  state.options = {...state.options, ...dossierKeys}; 
              }
          }
          
          
          },
      showVideo(state, action) {
          state.modal = MODAL_POPUP_TYPES.SHOW_VIDEO;
          state.show= true;
          state.key = uuid().slice(0, 8);
          state.options = action.payload;
          },
        
          hideModal(state:any = null, action = null) {
            state.modal = null;
              state.show= false;
              state.key = uuid().slice(0, 8);
              state.options = null;
          }
    // omit existing reducers here
  },
  extraReducers(builder) {
      
      
      
  }
})
export const { showConfirmModal, hideModal,showInvoiceAddRow,showSettingsStorageBasemapSelect, addDocument, searchWorkprocess, addCalenderItem,showVideo, detailDossier, showStoreConfirmModal } = ModalPopupReducer.actions;
export const dossiePopup = { addWorklog: ModalPopupReducer.actions.addWorklog, closeTask: ModalPopupReducer.actions.closeTask };
export default ModalPopupReducer.reducer